export default "__VITE_ASSET__dzdjMiYS__"